import { Skeleton, Table } from '@mantine/core';
import useModerationStaff from '../../../hooks/Moderation/staff/useModerationStaff';
import ContentCreator from '../../../components/ContentCreator/ContentCreator';
import TanStackTable from '../../../components/Table/TanStackTable/TanStackTable';
import ModerationStaffForm from '../ModerationStaffForm/ModerationStaffForm';
import PersonPage from '../../../components/PersonPage/PersonPage';


export default function AdministrativeUsersView() {
    const {
        data,
        columns,
        editFunc,
        displayForm,
        setDisplayForm,
        initialValuesEdit,
        setInitialValuesEdit,
        handleSubmit,
        formValidation,
        isLoading,
    } = useModerationStaff()


    return (
        <section className='AdministrativeView-layout--container'>
            {displayForm && (
                <ContentCreator
                    title={"Detalles del usuario"}
                    submitFunc={(values) => handleSubmit(values)}
                    onCancel={() => {
                        setDisplayForm(null)
                        setInitialValuesEdit(null)
                    }}
                    initialValues={initialValuesEdit ?? {}}
                    validation={formValidation}
                    renderPreview={(_form) => <PersonPage person={_form.form.values}/>}
                    renderForm={(_form) => <ModerationStaffForm form={_form.form} loading={isLoading} />}
                />
            )}

            {data && < TanStackTable
                data={data}
                columns={columns}
                editFunc={editFunc}
                displayForm={displayForm}
            />}

            {isLoading &&
                < Skeleton h='450px' w='100%' />}

        </section>
    )
}


